/**
 * @param path 接口路径
 * @param method 接口类型默认get，get、post、put
 * @param isFormData 默认false, 表单格式true，false为json格式
 * @param server 默认是hlw（zwww 政务网需要)
 * @param isBlob 
 */
module.exports = {
    hotel: {
        getHotelMaterial: {
            path: '/common/getHotelMaterial',
            method: 'POST',
            server: 'hotel'
        },
        getSignToken: {
            path: '/login/getSignToken',
            method: 'POST',
            server: 'hotel'
        },
        getPersonInfo: {
            path: '/login/getPersonInfo',
            method: 'POST',
            server: 'hotel'
        },
        // 地区
        getAreaCode: {
            path: '/common/getAreaCode',
            method: 'POST',
            server: 'hotel'
        },
        // 提交
        saveRequestBody: {
            path: '/common/saveRequestBody',
            method: 'POST',
            server: 'hotel',
        },
        // base64
        imageToBase64: {
            path: '/common/imageToBase64',
            method: 'POST',
            server: 'hotel',
            // isFormData: true
        },
        getList: {
            path: '/common/getList',
            method: 'POST',
            server: 'hotel',
        },
        deleteParamsById: {
            path: '/common/deleteParamsById',
            method: 'POST',
            server: 'hotel',
        },
        encryptString: {
            path: '/common/encryptString',
            method: 'POST',
            server: 'hotel',
        },
        pdfToImg: {
            path: '/common/pdfToImg',
            method: 'POST',
            server: 'hotel',
            isBolb: true
        },
    }
}


// WEBPACK FOOTER //
// ./src/conf/api/hotel.js